module.exports = __webpack_public_path__ + "static/img/other_FAQ_pic05.18b8f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_FAQ/other_FAQ_pic05.png
// module id = 557
// module chunks = 1